import numeral from 'numeral';

// ----------------------------------------------------------------------
numeral.register('locale', 'no', {
    delimiters: {
        thousands: ' ',
        decimal: ','
    },
    abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'b',
        trillion: 't'
    },
    ordinal: function () {
        return '.';
    },
    currency: {
        symbol: 'kr'
    }
});
numeral.locale('no');

export function fCurrency(number: string | number, format?: 'auto' | string | null) {
    if (number === undefined) {
        return ''
    }
    if (format && format === 'auto') {
        return numeral(number).format(Number.isInteger(number) ? '0,0' : '0,0.00');
    } else {
        return numeral(number).format(format ? format : '0,0');
    }
}

export function fPercent(number: number) {
    return numeral(number / 100).format('0.0%');
}

export function fNumber(number: string | number, format?: 'auto' | string | null) {
    if (format && format === 'auto') {
        return numeral(number).format(Number.isInteger(number) ? undefined : '0,0.00');
    } else {
        return numeral(number).format(format ? format : undefined);
    }
}

export function fShortenNumber(number: string | number) {
    return numeral(number).format('0.00a').replace(/[.,]00$/, '');
}

export function fData(number: string | number) {
    return numeral(number).format('0.0 b');
}
